// extracted by mini-css-extract-plugin
module.exports = {"root":"TimetableCell_root_2Pqci","active":"TimetableCell_active_1KU3z"};